export default __webpack_public_path__ + "static/media/destination-pin.b333f848.svg";